(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-advertorial-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var layoutBuilt = false;

    function setHeaderHeightVar() {
      var headerEl = document.querySelector('.pmd-advertorial-header');
      if (headerEl) {
        document.documentElement.style.setProperty('--pmd-header-height', headerEl.offsetHeight + 'px');
      }
    }

    function buildLayout() {
      if (layoutBuilt) return;
      if (window.innerWidth < 1100) return;

      var header = document.querySelector('.shopify-section:has(.pmd-advertorial-header)');
      if (!header) return;

      var allSections = Array.from(document.querySelectorAll('.shopify-section'));
      var sidebarSection = document.querySelector('.shopify-section:has(.pmd-advertorial-sidebar)');
      if (!sidebarSection) return;

      var footerSection = document.querySelector('.shopify-section:has(.pmd-advertorial-footer)');

      var contentSections = allSections.filter(function(s) {
        return s !== header && s !== sidebarSection && s !== footerSection;
      });

      var wrapper = document.createElement('div');
      wrapper.className = 'pmd-advertorial-page-layout';

      var main = document.createElement('div');
      main.className = 'pmd-advertorial-page-layout__main';

      var sidebar = document.createElement('div');
      sidebar.className = 'pmd-advertorial-page-layout__sidebar';

      contentSections.forEach(function(s) { main.appendChild(s); });
      sidebar.appendChild(sidebarSection);

      wrapper.appendChild(main);
      wrapper.appendChild(sidebar);

      header.insertAdjacentElement('afterend', wrapper);

      if (footerSection) {
        wrapper.insertAdjacentElement('afterend', footerSection);
      }

      layoutBuilt = true;
      setHeaderHeightVar();
    }

    function onResize() {
      setHeaderHeightVar();
      buildLayout();
    }

    function init() {
      buildLayout();
      setHeaderHeightVar();
      window.addEventListener('resize', onResize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-applp-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('pmd-applp-comparison-{{ section.id }}');
    if (!root) return;
    var scroller = root.querySelector('[data-pmd-applp-scroll]');
    var thumb = root.querySelector('[data-pmd-applp-thumb]');
    if (!scroller || !thumb) return;

    function updateThumb() {
      var scrollableWidth = scroller.scrollWidth - scroller.clientWidth;
      if (scrollableWidth <= 0) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }
      var thumbWidthPct = Math.max((scroller.clientWidth / scroller.scrollWidth) * 100, 8);
      var progress = scroller.scrollLeft / scrollableWidth;
      var maxTranslatePct = 100 - thumbWidthPct;
      thumb.style.width = thumbWidthPct + '%';
      thumb.style.transform = 'translateX(' + (progress * maxTranslatePct * (100 / thumbWidthPct)) + '%)';
    }

    scroller.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    updateThumb();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-applp-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pmd-applp-offer-disclosure]').forEach(function (disclosure) {
      var button = disclosure.querySelector('.pmd-applp-offer__toggle');
      var label = button && button.querySelector('.pmd-applp-offer__toggle-label');
      if (!button || !label) return;

      var seeMore = button.getAttribute('data-see-more') || label.textContent;
      var seeLess = button.getAttribute('data-see-less') || seeMore;

      button.addEventListener('click', function () {
        var open = disclosure.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? seeLess : seeMore;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-extra-tools"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.pmd-extra-tools__q');
    if (!summary) return;

    var item = summary.parentElement;
    var card = item.closest('.pmd-extra-tools__card');
    if (!card) return;

    if (!item.open) {
      card.querySelectorAll('.pmd-extra-tools__item[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    }

    var index = item.getAttribute('data-pmd-extra-tools-index');
    card.querySelectorAll('[data-pmd-extra-tools-media]').forEach(function (media) {
      media.classList.toggle('is-active', media.getAttribute('data-pmd-extra-tools-media') === index);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-first-60-days"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pmd-60-days-tabs')) {
    customElements.define('pmd-60-days-tabs', class Pmd60DaysTabs extends HTMLElement {
      connectedCallback() {
        this.navItems = this.querySelectorAll('.pmd-60-days__nav-item');
        this.panes = this.querySelectorAll('.pmd-60-days__tab-pane');
        
        this.navItems.forEach(item => {
          item.addEventListener('click', () => {
            const index = item.dataset.index;
            this.setActiveTab(index);
          });
        });
      }

      setActiveTab(index) {
        this.navItems.forEach(item => {
          if (item.dataset.index === index) {
            item.classList.add('pmd-60-days__nav-item--active');
          } else {
            item.classList.remove('pmd-60-days__nav-item--active');
          }
        });
        this.panes.forEach(pane => {
          if (pane.dataset.index === index) {
            pane.classList.add('pmd-60-days__tab-pane--active');
          } else {
            pane.classList.remove('pmd-60-days__tab-pane--active');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmd-quiz-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      if (root.dataset.quizInit) return;
      root.dataset.quizInit = 'true';

      var modal = root.querySelector('.pmd-quiz__modal');
      var screens = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-screen]'));
      var questions = screens.filter(function (s) {
        return s.dataset.quizScreen === 'question';
      });
      var intro = root.querySelector('[data-quiz-screen="intro"]');
      var votes = [];
      var storageKey = 'pmd-quiz-shown-' + root.dataset.sectionId;
      var designMode = window.Shopify && window.Shopify.designMode;

      function updateProgress() {
        questions.forEach(function (q, i) {
          var label = q.querySelector('[data-quiz-progress]');
          var bar = q.querySelector('[data-quiz-progressbar]');
          if (label) label.textContent = 'Step ' + (i + 1) + ' of ' + questions.length;
          if (bar) bar.style.width = ((i + 1) / questions.length) * 100 + '%';
        });
      }

      function showScreen(el) {
        screens.forEach(function (s) {
          s.classList.toggle('is-active', s === el);
        });
        var key = el && el.dataset.quizScreen ? el.dataset.quizScreen : 'intro';
        var type = 'intro';
        if (key.indexOf('result') === 0) type = 'result';
        else if (key === 'question') type = 'question';
        root.classList.toggle('is-intro', type === 'intro');
        root.classList.toggle('is-question', type === 'question');
        root.classList.toggle('is-result', type === 'result');
        if (modal) modal.scrollTop = 0;
      }

      function open() {
        root.hidden = false;
        document.body.classList.add('pmd-quiz-open');
        var closeBtn = root.querySelector('.pmd-quiz__close');
        if (closeBtn) closeBtn.focus();
        root.dispatchEvent(new CustomEvent('pmd-quiz:open', { bubbles: true }));
      }

      function close() {
        root.hidden = true;
        document.body.classList.remove('pmd-quiz-open');
      }

      function reset() {
        votes = [];
        root.querySelectorAll('[data-quiz-option].is-selected').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        if (intro) showScreen(intro);
      }

      function finish() {
        var a = votes.filter(function (v) {
          return v === 'a';
        }).length;
        var b = votes.filter(function (v) {
          return v === 'b';
        }).length;
        var key = b > a ? 'b' : 'a';
        var result = root.querySelector('[data-quiz-screen="result-' + key + '"]');
        if (result) showScreen(result);
        root.dispatchEvent(
          new CustomEvent('pmd-quiz:complete', {
            bubbles: true,
            detail: { result: key, votes: votes.slice() }
          })
        );
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-quiz-close]')) {
          close();
          return;
        }
        if (e.target.closest('[data-quiz-start]')) {
          if (questions.length) showScreen(questions[0]);
          else finish();
          return;
        }
        var addBtn = e.target.closest('[data-quiz-add]');
        if (addBtn) {
          var variantId = addBtn.getAttribute('data-variant-id');
          if (variantId) {
            if (typeof window.ADD_TO_CART === 'function') {
              window.ADD_TO_CART(variantId, 1);
              close();
            } else {
              addBtn.setAttribute('aria-disabled', 'true');
              fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
              })
                .then(function () {
                  window.location.href = '/cart';
                })
                .catch(function () {
                  addBtn.removeAttribute('aria-disabled');
                });
            }
          }
          return;
        }
        var back = e.target.closest('[data-quiz-back]');
        if (back) {
          var current = back.closest('[data-quiz-screen]');
          var idx = questions.indexOf(current);
          if (idx > 0) showScreen(questions[idx - 1]);
          else if (intro) showScreen(intro);
          return;
        }
        var option = e.target.closest('[data-quiz-option]');
        if (option) {
          var screen = option.closest('[data-quiz-screen]');
          screen.querySelectorAll('[data-quiz-option]').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          option.classList.add('is-selected');
          var i = questions.indexOf(screen);
          votes[i] = option.dataset.quizResult || 'neutral';
          window.setTimeout(function () {
            if (i < questions.length - 1) showScreen(questions[i + 1]);
            else finish();
          }, 250);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) close();
      });

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-pmd-quiz-open], a[href$="#pmd-quiz"]');
        if (!trigger) return;
        e.preventDefault();
        reset();
        open();
      });

      if (!designMode && root.dataset.autoOpen === 'true') {
        var frequency = root.dataset.frequency;
        var store = frequency === 'once_per_visitor' ? window.localStorage : window.sessionStorage;
        var seen = false;
        try {
          seen = frequency !== 'every_visit' && !!store.getItem(storageKey);
        } catch (err) {
          seen = false;
        }
        if (!seen) {
          window.setTimeout(function () {
            open();
            try {
              store.setItem(storageKey, '1');
            } catch (err) {
              /* storage unavailable */
            }
          }, (parseInt(root.dataset.openDelay, 10) || 0) * 1000);
        }
      }

      if (designMode) {
        document.addEventListener('shopify:section:select', function (e) {
          if (e.target.contains(root)) {
            reset();
            open();
          }
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (e.target.contains(root)) close();
        });
      }

      if (questions.length) {
        var firstBack = questions[0].querySelector('[data-quiz-back]');
        if (firstBack) firstBack.style.display = 'none';
      }

      updateProgress();
    }

    function initAll() {
      document.querySelectorAll('.pmd-quiz').forEach(initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
